<template>
  <div v-if="backdrop">
    <div
      class="modal fade"
      :class="modal.open ? 'show' : ''"
      style="display: block"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      @click="
        dismiss
          ? $event.target.classList.contains('modal')
            ? close()
            : true
          : true
      "
    >
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              {{ config.title == null ? "&nbsp;" : config.title }}
            </h5>
            <button
              type="button"
              class="close"
              @click="close()"
              v-html="request ? spin() : ic('close')"
            />
          </div>

          <div class="modal-body pt-3" style="min-height: 300px">
            <form @submit.prevent="_search">
              <div class="row">
                <div class="col-6" style="width: calc(100% - 281px)">
                  <div class="form-group">
                    <label class="form-label" v-html="'Tim - Salesman'" />
                    <selectize
                      v-model="data.id_salesman"
                      data-placeholder="Pilih tim"
                      required
                    >
                      <option :value="d.id" v-for="(d, i) in salesman" :key="i">
                        {{ d.tim + " - " + d.nama_salesman }}
                      </option>
                    </selectize>
                  </div>
                </div>
                <div class="col-4" style="width: 200px">
                  <div class="form-group">
                    <label class="form-label" v-html="'Tanggal'" />
                    <input
                      type="date"
                      v-model="data.date"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="col-auto text-right">
                  <div class="form-group">
                    <label class="form-label" v-html="'&nbsp;'" />
                    <button
                      class="btn btn-primary"
                      :disabled="request || loading"
                      v-html="ic('search')"
                    />
                  </div>
                </div>
              </div>
            </form>

            <div>
              <Nodata v-if="!loading && invoices.length == 0" />
              <Skeleton
                type="table"
                :length="5"
                class="mt-3 bg-white"
                v-if="loading"
                style="overflow: hidden"
              />

              <div class="card bg-white" v-if="!loading && invoices.length > 0">
                <table
                  class="
                    table table-vcenter table-hover
                    card-table
                    table-striped
                  "
                >
                  <thead>
                    <th v-html="'No. PO'" />
                    <th v-html="'No. Invoice'" />
                    <th v-html="'Toko'" />
                    <th class="text-right pos-relative">
                      <label
                        class="form-check"
                        style="position: absolute; top: 4px; right: 10px"
                      >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          :checked="invoices.length == checkeds.length"
                          @click="checkAll"
                        />
                        <span class="form-check-label"></span>
                      </label>
                    </th>
                  </thead>
                  <tbody>
                    <template v-for="(d, i) in invoices">
                      <template v-if="d.invoice_type == 'invoice'">
                        <tr :key="i + '_proforma'">
                          <td v-html="d.id" />
                          <td>
                            <ul style="list-style-type: none; margin-top: 10px">
                              <li>
                                {{ d.no_invoice }}
                              </li>
                              <li>
                                <span v-html="'proforma'" class="badge w-50" :class="d.invoice_type != null ? invoiceTypeClass.proforma : 'bg-default'" />
                              </li>
                            </ul>
                          </td>
                          <td v-html="' [' + d.toko.no_acc + '] ' + d.toko.nama_toko" />
                          <td class="text-right pos-relative">
                            <label class="form-check" style="position: absolute; top: 32px; right: 10px">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                @click="checkInvoice(d.id, 'proforma')"
                                :checked="checkeds.findIndex(item => (item.id === d.id && item.type === 'proforma') ) !== -1"
                              />
                              <span class="form-check-label"></span>
                            </label>
                          </td>
                        </tr>
                        <tr :key="i + '_invoice'">
                          <td v-html="d.id" />
                          <td>
                            <ul style="list-style-type: none; margin-top: 10px">
                              <li>
                                {{ d.no_invoice }}
                              </li>
                              <li>
                                <span v-html="'invoice'" class="badge w-50" :class="d.invoice_type != null ? invoiceTypeClass.invoice : 'bg-default'" />
                              </li>
                            </ul>
                          </td>
                          <td v-html="' [' + d.toko.no_acc + '] ' + d.toko.nama_toko" />
                          <td class="text-right pos-relative">
                            <label class="form-check" style="position: absolute; top: 32px; right: 10px">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                @click="checkInvoice(d.id, 'invoice')"
                                :checked="checkeds.findIndex(item => (item.id === d.id && item.type === 'invoice') ) !== -1"
                              />
                              <span class="form-check-label"></span>
                            </label>
                          </td>
                        </tr>
                      </template>
                      <template v-if="d.invoice_type == 'proforma'">
                        <tr :key="i + '_proforma'">
                          <td v-html="d.id" />
                          <td>
                            <ul style="list-style-type: none; margin-top: 10px">
                              <li>
                                {{ d.no_invoice }}
                              </li>
                              <li>
                                <span v-html="'proforma'" class="badge w-50" :class="d.invoice_type != null ? invoiceTypeClass.proforma : 'bg-default'" />
                              </li>
                            </ul>
                          </td>
                          <td v-html="' [' + d.toko.no_acc + '] ' + d.toko.nama_toko" />
                          <td class="text-right pos-relative">
                            <label class="form-check" style="position: absolute; top: 32px; right: 10px">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                @click="checkInvoice(d.id, 'proforma')"
                                :checked="checkeds.findIndex(item => (item.id === d.id && item.type === 'proforma') ) !== -1"
                              />
                              <span class="form-check-label"></span>
                            </label>
                          </td>
                        </tr>
                      </template>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="px-4 py-3 text-right" style="border-top: 1px #ddd solid">
            <strong
              class="float-left mt-1"
              v-html="'TOTAL PROFORMA : ' + countProforma + ' TOTAL INVOICE : ' + countInvoice"
              v-if="countProforma > 0 || countInvoice > 0"
            />
            <strong
              class="float-left mt-1 ml-3 text-success"
              v-if="success.length > 0"
              v-html="success.length + '' + ic('check')"
            />
            <strong
              class="float-left mt-1 ml-2 text-danger"
              v-if="failed.length > 0"
              v-html="failed.length + '' + ic('close')"
            />
            <button
              type="button"
              class="btn btn-white"
              @click="close()"
              v-html="'Tutup'"
            />
            <button
              type="button"
              class="btn btn-primary ml-3"
              @click="download"
              :disabled="isDownload || checkeds.length == 0"
              v-html="
                isDownload
                  ? spin() + ' Download ' + checkeds.length + ' Invoice'
                  : ic('download') + ' Download Invoice'
              "
            />
          </div>
        </div>
      </div>
    </div>

    <div class="modal-backdrop fade" :class="modal.open ? 'show' : ''" />
  </div>
</template>

<script>
import helper from "@/assets/js/helper.js";

export default {
  name: "Modal",
  props: {
    config: {
      default: {
        view: false,
        title: "Print Invoice",
      },
    },
    initData: null,
    isSubmit: { default: false },
    dismiss: { default: true },
  },

  mixins: [helper],

  data() {
    return {
      backdrop: false,
      modal: {
        open: false,
        formNav: 0,
      },

      countProforma: 0,
      countInvoice: 0,

      request: true,
      loading: false,
      isDownload: false,
      salesman: [],
      invoices: [],
      filename: null,

      data: {
        id_salesman: null,
        date: this.dateTime("ymd"),
      },

      checkeds: [],
      inPreview: [],
      success: [],
      failed: [],

      invoiceTypeClass: {
        proforma: "bg-orange",
        invoice: "bg-green",
      },
    };
  },

  methods: {
    close() {
      this.$emit("update:config", { view: false });
    },

    _getSalesman() {
      this.request = true;

      this.axios
        .get("salesman")
        .then((res) => {
          this.salesman = res.data.data;
          this.request = false;
        })
        .catch((err) => {
          this.onError(err);
          this.request = false;
        });
    },

    // _printPage(depo) {
    //   if (depo == "singaraja" || depo == "bangli" || depo == "negara") {
    //     window.open(
    //       window.location.origin + "/dashboard/sales/print-invoice-2",
    //       "_blank"
    //     );
    //   } else {
    //     window.open(
    //       window.location.origin + "/dashboard/sales/print-invoice",
    //       "_blank"
    //     );
    //   }
    // },
    
    _printPage(type) {
      if (type == "invoice") {
        window.open(
          window.location.origin + "/dashboard/sales/print-invoice-items",
          "_blank"
        );
      } else {
        window.open(
          window.location.origin + "/dashboard/sales/print-proforma-invoice-items",
          "_blank"
        );
      }
    },

    _search() {
      this.loading = true;
      this.axios(
        "penjualan/list/invoice_pdf?id_salesman=" +
          this.data.id_salesman +
          "&date=" +
          this.data.date
      )
      .then((res) => {
        this.invoices = res.data.data;
        this.filename = res.data.nama_tim + "_inv_penjualan_";
        this.loading = false;

        this.invoices.forEach((item) => {
          if (item.invoice_type == 'invoice') {
            this.countProforma += 1;
            this.countInvoice += 1;
          } else if (item.invoice_type == 'proforma') {
            this.countProforma += 1;
          }
        });
      })
      .catch((err) => {
        this.loading = false;
        this.onError(err);
      });
    },

    // checkInvoice(npo) {
    //   this.checkeds.indexOf(npo) > -1
    //     ? this.checkeds.splice(this.checkeds.indexOf(npo), 1)
    //     : this.checkeds.push(npo);
    // },
    
    checkInvoice(id, type) {
      const existingItemIndex = this.checkeds.findIndex(item => (item.id === id && item.type === type) );
      if (existingItemIndex !== -1) {
        this.checkeds.splice(existingItemIndex, 1);
      } else {
        this.checkeds.push({
          id: id,
          type: type
        });
      }

      console.log(this.checkeds);
    },

    checkAll() {
      let npos = [];
      this.invoices.forEach((f) => {
        if (f.invoice_type == 'invoice') {
          npos.push({
            id: f.id,
            type: 'proforma'
          });
          npos.push({
            id: f.id,
            type: 'invoice'
          });
        } else if (f.invoice_type == 'proforma') {
          npos.push({
            id: f.id,
            type: 'invoice'
          });
        }
      });
      this.checkeds = this.checkeds.length == this.countProforma + this.countInvoice ? [] : npos;
    },

    // async download() {
    //   this.isDownload = true;
    //   this.success = [];
    //   this.failed = [];
    //   let checkeds = this.checkeds;
    //   for (let i = 0; i < checkeds.length; i++) {
    //     await this.axios({
    //       method: "get",
    //       url: "penjualan_pdf/" + checkeds[i],
    //     })
    //       .then((res) => {
    //         let depo = res.data.data.nama_depo;
    //         localStorage.invoice = JSON.stringify(res.data);
    //         this._printPage(depo.toLowerCase());
    //       })
    //       .catch((err) => {
    //         this.failed.push(checkeds[i]);
    //         this.catch(this, err.response);
    //       });

    //     if (i == this.checkeds.length - 1) {
    //       this.isDownload = false;
    //     }
    //   }
    // },

    async download() {
      this.isDownload = true;
      this.success = [];
      this.failed = [];
      let checkeds = this.checkeds;
      for (let i = 0; i < checkeds.length; i++) {
        if (checkeds[i].type == 'invoice') {
          await this.axios({
            method: "get",
            url: "penjualan_pdf/invoice/" + checkeds[i].id,
          })
          .then((res) => {
            let depo = res.data.data.nama_depo;
            localStorage.invoiceItems = JSON.stringify(res.data);
            this._printPage(checkeds[i].type);
          })
          .catch((err) => {
            this.failed.push(checkeds[i]);
            this.catch(this, err.response);
          });
        } else {
          await this.axios({
            method: "get",
            url: "penjualan_pdf/proforma/" + checkeds[i].id,
          })
          .then((res) => {
            let depo = res.data.data.nama_depo;
            localStorage.proformaItems = JSON.stringify(res.data);
            this._printPage(checkeds[i].type);
          })
          .catch((err) => {
            this.failed.push(checkeds[i]);
            this.catch(this, err.response);
          });
        }

        if (i == this.checkeds.length - 1) {
          this.isDownload = false;
        }
      }
    },
  },

  watch: {
    "config.view": function (view) {
      if (view) {
        this.$emit("update:isSubmit", false);
        this.backdrop = true;
        setTimeout(() => {
          this.modal.open = view;
          if (this.salesman.length == 0) this._getSalesman();
        }, 100);
      } else {
        this.modal.open = view;
        setTimeout(() => {
          this.backdrop = view;
        }, 100);
      }
    },

    initData: function (data) {},
  },
};
</script>

<style lang="scss" src="../penjualan.scss" scoped/>
